import React from "react";
import {
  Avatar,
  Box,
  Chip,
  Paper,
  Stack,
  Typography,
  alpha,
} from "@mui/material";
import GroupAddOutlinedIcon from "@mui/icons-material/GroupAddOutlined";
import Note from "../../../library/Note";

export default function BulkAccountCreation() {
  return (
    <Stack spacing={2.5} sx={{ p: { xs: 2, lg: 3 }, minWidth: 0 }}>
      <Stack direction='row' spacing={1.5} alignItems='center'>
        <Avatar
          variant='rounded'
          sx={{
            width: 46,
            height: 46,
            borderRadius: 3,
            bgcolor: (theme) => alpha(theme.palette.primary.main, 0.1),
            color: "primary.main",
          }}
        >
          <GroupAddOutlinedIcon />
        </Avatar>
        <Box sx={{ minWidth: 0 }}>
          <Typography component='h1' variant='h5' fontWeight={750}>
            Bulk Account Creation
          </Typography>
          <Typography variant='body2' color='text.secondary'>
            Create multiple accounts at once.
          </Typography>
        </Box>
      </Stack>
      <Paper variant='outlined' sx={{ p: { xs: 2, sm: 2.5 }, borderRadius: 3 }}>
        <Stack spacing={2}>
          <Chip
            label='Coming soon'
            size='small'
            variant='outlined'
            sx={{ alignSelf: "flex-start" }}
          />
          <Note title='Bulk account creation is not available yet'>
            <Typography variant='body2' color='text.secondary'>
              You’ll be able to create accounts here once this feature is ready.
            </Typography>
          </Note>
        </Stack>
      </Paper>
    </Stack>
  );
}
